export const ERROR_TYPE = {
  REQUIRED: 'required',
  INVALID: 'invalid',
  NONE: 'none',
};

export const FORM_TYPE = {
  CREATE: 'create',
  EDIT: 'edit',
};

export const Constants = {
  events: [
    { id: 1, name: 'Program' },
    { id: 2, name: 'Series' },
    { id: 3, name: 'Season' },
    { id: 4, name: 'Title Group' },
    { id: 5, name: 'None' },
  ],
  defaultBreakPatternData: {
    type: '',
    slotPosition: '',
    optional: false,
    priority: 0,
    selection: '',
    eventName: '',
    externalID: '',
    position: 0,
    assetID: null,
    id: crypto.randomUUID(),
  },
  defaultSegmentPositions: [
    ...Array.from({ length: 20 }, (_, i) => ({ name: `${i + 1}` })),
    { name: 'All But Last Segment' },
    { name: 'Before Asset' },
    { name: 'First Segment' },
    { name: 'Last Segment' },
    { name: 'Odd Segments' },
    { name: 'Even Segments' },
    { name: 'All Segments' },
    { name: 'Middle Segment' },
    { name: 'After Asset' },
  ],
  defaultSelectionOptions: [{ name: 'Rotation' }, { name: 'Shuffle' }, { name: 'Prevent Breaks' }],
  defaultFormErrors: {
    contentLevel: {
      eventName: '',
      eventType: '',
    },
    breakChannelTableError: '',
    hasErrors: false,
    versionName: '',
  },
  defaultBreakChannelTypeFormErrors: {
    slotPosition: '',
    selection: '',
    hasErrors: false,
  },
};
